import { render, staticRenderFns } from "./bumdesKelembagaan.vue?vue&type=template&id=f6ed1c50&"
import script from "./bumdesKelembagaan.vue?vue&type=script&lang=js&"
export * from "./bumdesKelembagaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QBtnDropdown,QList,QItem,QItemSection,QAvatar,QItemLabel,QPagination,QDialog,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QBtnDropdown,QList,QItem,QItemSection,QAvatar,QItemLabel,QPagination,QDialog,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
